import React from "react";
import { DOTS, usePagination } from "../../hooks/usePagination";
import "./style.css";
import { PaginationProps } from "../../../../types";

const Pagination: React.FC<PaginationProps> = ({
  onPageChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  showRowPerPage,
  handlePerChange,
  paginatorOptions,
}) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount, // Correct property name
    siblingCount,
    showRowPerPage, // Correct property name
  });

  // Check if paginationRange is undefined or empty
  if (!paginationRange || paginationRange.length < 1) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  const lastPage = paginationRange[paginationRange.length - 1] as number;

  return (
    <div className="pagination-main-container">
      <ul className={"pagination-container"}>
        {/* Left navigation arrow */}
        <li
          className={`pagination-item ${currentPage === 1 ? "disabled" : ""}`}
          onClick={onPrevious}
        >
          <div className="arrow left" />
        </li>
        {paginationRange.map((pageNumber, index) => {
          // If the pageItem is a DOT, render the DOTS unicode character
          if (pageNumber === DOTS) {
            return (
              <li key={`dots-${index}`} className="pagination-item dots">
                &#8230;
              </li>
            );
          }

          // Render Page Pills
          return (
            <li
              key={`page-${pageNumber}`}
              className={`pagination-item ${
                pageNumber === currentPage ? "selected" : ""
              }`}
              onClick={() => onPageChange(pageNumber as number)}
            >
              {pageNumber}
            </li>
          );
        })}
        <li
          className={`pagination-item ${
            currentPage === lastPage ? "disabled" : ""
          }`}
          onClick={onNext}
        >
          <div className="arrow right" />
        </li>
      </ul>
      <select
        onChange={(e) => handlePerChange(Number(e.target.value))}
        value={showRowPerPage}
        style={{
          height: "25px",
          width: "60px",
        }}
      >
        {paginatorOptions.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Pagination;
